import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import { MultiSwitch } from '../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { ChartDataList } from '../../../../../../atomic/inputs/datalist/chartDataList/ChartDataList';
import { Body3 } from '../../../../../../atomic/text/Text';
// import BidAskBox from './BidAskBox';
import style from './ChartHeader.module.css';

function ChartHeader({
  type,
  setters,
  symbol,
  dataSource,
  brokerage,
  numberOfCandles,
  timeUnit,
  candleDuration,
  showCandleNumbers,
}) {
  const candleNumberArray = [5, 10, 20, 30, 40, 50];
  const timeUnitArray = [
    { value: 'MINUTES', label: 'Min.' },
    { value: 'DAYS', label: 'Day' },
    { value: 'WEEKS', label: 'Week' },
    { value: 'MONTHS', label: 'Month' },
  ];
  const candleDurationArray = [1, 3, 5, 10, 15, 20, 30, 60, 120];

  const {
    setSymbol,
    setDataSource,
    setNumberOfCandles,
    setTimeUnit,
    setCandleDuration,
    setShowCandleNumbers,
  } = setters;

  const [symbolDisplay, setSymbolDisplay] = useState(symbol);

  return (
    <div className={style.container}>
      {type === 'tradeplan' ? (
        <div className={style.textWrapper}>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            {symbol}
          </Body3>
        </div>
      ) : (
        <div className={style.inputWrapper}>
          <input
            className={style.input}
            type="text"
            value={symbolDisplay}
            onChange={({ target }) => setSymbolDisplay(target.value)}
            onBlur={() => setSymbol(symbolDisplay)}
          />
          <img
            className={style.searchIcon}
            src="https://res.cloudinary.com/glasswavs/image/upload/v1632778351/outline_search_white_24dp_vculzf.png"
            alt=""
            width="15px"
          />{' '}
        </div>
      )}

      {type === 'tradeplan' ? (
        <div className={style.textWrapper}>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            {dataSource === 'LIVE' ? 'Live' : 'Backtest'}
          </Body3>
        </div>
      ) : (
        <select
          className={style.select}
          name="dataSource"
          id="dataSource"
          value={dataSource}
          onChange={({ target }) => setDataSource(target.value)}
        >
          <option value="SIMULATED">Sim</option>
          <option value="LIVE">Live</option>
        </select>
      )}

      <select
        className={style.select}
        name="numberOfCandles"
        id="numberOfCandles"
        value={numberOfCandles}
        onChange={({ target }) => setNumberOfCandles(Number(target.value))}
      >
        {candleNumberArray.map((value) => (
          <option value={value} key={value}>
            {value + 'x'}
          </option>
        ))}
      </select>
      {/* <select
        className={style.select}
        name="candleDuration"
        id="candleDuration"
        value={candleDuration}
        onChange={({ target }) => setCandleDuration(Number(target.value))}
      >
        {candleDurationArray.map((value) => (
          <option value={value} key={value}>
            {value}
          </option>
        ))}
      </select> */}
      <ChartDataList
        backgroundColor={colors.grey}
        id="candleDuration"
        dataList={candleDurationArray}
        controlledValue={candleDuration}
        onBlurFn={(value) => setCandleDuration(value)}
        dataListMapFn={(value) => (
          <option key={value} value={value}>
            {value}
          </option>
        )}
      >
        ...
      </ChartDataList>
      <select
        className={style.select}
        name="timeUnit"
        id="timeUnit"
        value={timeUnit}
        onChange={({ target }) => setTimeUnit(target.value)}
      >
        {timeUnitArray.map(({ value, label }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </select>
      <MultiSwitch
        margin="0 0 0 3px"
        labels={['1-2-3', 'Off']}
        values={[true, false]}
        setValue={setShowCandleNumbers}
        controlledValue={showCandleNumbers}
      />
      {/* <BidAskBox symbol={symbol} dataSource={dataSource} /> */}
    </div>
  );
}

ChartHeader.propTypes = {
  brokerage: PropTypes.string,
  candleDuration: PropTypes.any,
  dataSource: PropTypes.string,
  headerData: PropTypes.shape({
    ask: PropTypes.number,
    bid: PropTypes.number,
    last: PropTypes.number,
    volume: PropTypes.number,
  }),
  numberOfCandles: PropTypes.any,
  setters: PropTypes.shape({
    setBrokerage: PropTypes.func,
    setCandleDuration: PropTypes.func,
    setDataSource: PropTypes.func,
    setNumberOfCandles: PropTypes.func,
    setShowCandleNumbers: PropTypes.any,
    setSymbol: PropTypes.func,
    setTimeUnit: PropTypes.func,
  }),
  showCandleNumbers: PropTypes.any,
  symbol: PropTypes.any,
  timeUnit: PropTypes.any,
  type: PropTypes.string.isRequired,
  values: PropTypes.shape({
    brokerage: PropTypes.string,
    candleDuration: PropTypes.any,
    dataSource: PropTypes.string,
    numberOfCandles: PropTypes.any,
    showCandleNumbers: PropTypes.any,
    symbol: PropTypes.any,
    timeUnit: PropTypes.any,
  }),
};

export default ChartHeader;
